import React from 'react'
import styled from "styled-components";
import { GapWrapper, HighlightSpan, TitleP } from "../components/styled/Styled";
import { HeaderButton } from "../components/buttons/HeaderButton";
import { contactLink } from "../constants/links";
import { Walletimg } from '../assets/img/Images';



export const Wallet = () => {
  return (
    <div className='poka-pattern'>
       <Wrapper className="container flexSpaceCenter">
       <LeftSide className="flex flexColumn">
          <GapWrapper gap={10}>
            <div
              data-aos="fade-up"
              data-aos-delay="300"
              data-aos-duration="1500"
            >
              <h1 className="extraBold font60">
                <HighlightSpan>Zimba Wallet</HighlightSpan>
              </h1>
            </div>
            <div
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-delay="600"
            >
              <div className="font18 extraBold">
              Simplifying Cashless Payments for Institutions and Their Customers
              </div>
            </div>
          </GapWrapper>

          <div data-aos="fade-up" data-aos-duration="1500" data-aos-delay="800">
            <TitleP className="font14">
            At  <b>Zimba</b>, we recognized the need for a more convenient and affordable solution for institutions and their customers to manage cashless payments.
            That’s why we partnered with <b>Clic World</b> and <b>ABC Bank</b>  to create the Zimba Wallet, a modern and secure digital wallet designed to meet the evolving needs of financial institutions and their clients.


              <br />
              <br />
            </TitleP>
          </div>

          <div
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-delay="1000"
          >
            <HeaderButton to={contactLink}><p className='gilroy'>More Info</p></HeaderButton>
          </div>
        </LeftSide>
        <RightSide>
          <div
            data-aos="fade-up"
            data-aos-duration="1500"
            data-aos-delay="1000"
            className=''
          >
           <img width={440} src= {Walletimg} alt='wallet'/>
          </div>
        </RightSide>
       </Wrapper>
    </div>
  )
}
const Wrapper = styled.section`
  padding-top: 70px;
  width: 100%;
  min-height: 90vh;
  @media (max-width: 960px) {
    flex-direction: column;
    min-height: 100%;
  }
`;

const LeftSide = styled.div`
  width: 50%;
  gap: 40px;
  height: 100%;
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
    margin: 50px 0;
    text-align: center;
  }
  @media (max-width: 560px) {
    margin: 80px 0 50px 0;
  }
`;

const RightSide = styled.div`
  width: 50%;
  padding: 30px;
  @media (max-width: 960px) {
    width: 100%;
    order: 1;
  }
`;